import { render, staticRenderFns } from "./CostTemplateManage.vue?vue&type=template&id=4557bd33&scoped=true"
import script from "./CostTemplateManage.vue?vue&type=script&lang=js"
export * from "./CostTemplateManage.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CostTemplateManage.vue?vue&type=style&index=1&id=4557bd33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4557bd33",
  null
  
)

export default component.exports